/** Material UI Packages. */
import { Tooltip, IconButton, Box, Typography } from '@mui/material';

/** Material UI Icons. */
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export const acctCol = (handleClickOpen, handleClickDelete, tradePartnerList) => [
    { field: 'id', headerName: 'ID', align: 'center', headerAlign: 'center', flex: 0.2 },
    { field: 'exist', headerName: 'Exist', align: 'center', headerAlign: 'center', flex: 0.2, hide: true },
    {
        field: 'email',
        headerName: 'Account ID',
        flex: 1.2,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'company_name',
        headerName: 'Company Name',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'company_position',
        headerName: 'Position',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'first_name',
        headerName: 'First Name',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'last_name',
        headerName: 'Last Name',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'create_at',
        headerName: 'Created At',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (value) => {
            if (!value) return '';
            const date = new Date(value);
            return date.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            });
        },
    },
    {
        field: 'last_login',
        headerName: 'Last Login',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (value) => {
            if (!value) return '';
            const date = new Date(value);
            const dateStr = date.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            });
            const timeStr = date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            });
            return `${dateStr} @${timeStr}`;
        },
    },
    {
        field: 'logins_count',
        headerName: 'Logins Count',
        flex: 0.6,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'email_verified',
        headerName: 'Verified',
        flex: 0.4,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (value) => {
            return value ? 'O' : 'X';
        },
    },
    {
        field: 'user_role',
        headerName: 'User Role',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'service_name',
        headerName: 'Service Name',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'il_customer_tradepartner_map',
        headerName: 'TP Sharing',
        flex: 1.2,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (value) => {
            if (!value || !Array.isArray(value)) return '';

            const tradePartnerIds = value.map((item) => item.il_trade_partner_id);
            const matchedNames = tradePartnerIds
                .map((id) => {
                    const matchedTP = tradePartnerList.find((tp) => tp.id === id);
                    return matchedTP ? matchedTP.name : null;
                })
                .filter((name) => name !== null);
            return matchedNames.join(', ');
        },
    },
    {
        field: 'actions',
        headerName: 'Actions',
        align: 'center',
        headerAlign: 'center',
        type: 'actions',
        renderCell: (params) => (
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                <Tooltip title="Settings">
                    <IconButton size="small" onClick={(event) => handleClickOpen(event, params.id)}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                    <IconButton
                        size="small"
                        onClick={(event) => handleClickDelete(event, params.id)}
                        disabled={params.row.exist}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),
    },
];

export const TPRowsCol = (handleDeleteTP) => [
    { field: 'id', headerName: 'ID', align: 'center', headerAlign: 'center', flex: 0.2, hide: true },
    { field: 'name', headerName: 'Name', flex: 2 },
    { field: 'fullname', headerName: 'Full name', flex: 7 },
    {
        field: 'status',
        headerName: 'Status',
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        renderCell: (params) => (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Typography
                    sx={{
                        fontSize: 12,
                        color: params.value ? 'success.main' : 'error.main',
                    }}
                >
                    {params.value ? 'Active' : 'Inactive'}
                </Typography>
            </Box>
        ),
    },
    {
        field: 'actions',
        headerName: '',
        align: 'center',
        headerAlign: 'center',
        flex: 0.2,
        type: 'actions',
        renderCell: (params) => (
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                <Tooltip title="Delete">
                    <IconButton size="small" onClick={(event) => handleDeleteTP(event, params.row)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),
    },
];
